import { BaseFileModel } from '../data';

export interface TransactionalEmailFilesPayloadModel {
  files: BaseFileModel[];
}
